import {
  Component,
  OnInit,
  AfterViewInit,
  Input,
  OnChanges,
  SimpleChanges,
  OnDestroy
} from "@angular/core";
import * as Highcharts from "highcharts";
import addMore from "highcharts/highcharts-more";
import { TranslateService } from "@ngx-translate/core";
import { OverallOtifService } from "./service/widget-overall-otif.service";
import { LocalStorageService } from "../../../../shared/services/local-storage.service";
import { BroadcasterService } from "../../../../core/services/broadcaster.service";
import * as HSET from "./settings";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
addMore(Highcharts);
@Component({
  selector: "widget-overall-otif",
  templateUrl: "./widget-overall-otif.component.html",
  styleUrls: ["./widget-overall-otif.component.scss"],
  providers: [OverallOtifService]
})
export class WidgetOverallOtifComponent implements OnInit, OnChanges, OnDestroy {
  private unsubscribe: Subject<void> = new Subject();
  @Input() FILTERS;
  @Input() OPTIONS;
  errorMessage = "";
  widgetId = 1;
  highcharts: typeof Highcharts = Highcharts;
  chartOptions = null;
  targetData = [];
  target = "";
  mockChart = null;
  loadingChart = true;

  constructor(
    private translateService: TranslateService,
    private dataService: OverallOtifService,
    private broadcaster: BroadcasterService,
    private localStorageService: LocalStorageService
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.FILTERS) {
      if (
        JSON.stringify(changes.FILTERS.currentValue) !==
        JSON.stringify(changes.FILTERS.previousValue) &&
        !changes.FILTERS.firstChange
      ) {
        this.getOverallOtifData();
      }
    }
  }

  ngOnInit() {
    this.translateService
      .get("PERFORMANCE.DELIVERY.OVERALL_OTIF")
      .pipe(takeUntil(this.unsubscribe)).subscribe(text => {
        this.OPTIONS.title = this.OPTIONS.title || text;
      });
    this.broadcaster.listen("PAGE_WIDGET_DATA")
      .pipe(takeUntil(this.unsubscribe)).subscribe(() => {
        this.setWidgetData();
      });
    this.chartOptions = HSET.chartData;
    this.getOverallOtifData();
  }
  setWidgetData() {
    const pageData = this.localStorageService.getItem("PAGE_WIDGET_DATA");
    if (pageData) {
      pageData.forEach(element => {
        if (element.widget_id === this.widgetId) {
          this.setTarget(element.target);
        }
      });
    }
  }

  setTarget(t) {
    if (this.chartOptions) {
      this.chartOptions.series[1].data = [t, t, t];
    }
  }

  getOverallOtifData() {
    //this.chartOptions = null;
    this.loadingChart = true;
    this.mockChart = null;
    this.errorMessage = "";
    this.dataService
      .getOverallOtifData(this.OPTIONS.api, this.FILTERS)
      .pipe(takeUntil(this.unsubscribe)).subscribe(
        (chart): any => {

          if (chart && chart.length) {
            this.loadingChart = false;
            this.chartOptions = this.dataService.createChart(
              chart,
              this.OPTIONS
            );
            this.setWidgetData();
          } else {
            this.loadingChart = true;
            this.errorMessage = "ERROR_MSG.NO_DATA";
            this.mockChart = HSET.chartData;
          }
        },
        error => {
          this.loadingChart = true;
          this.errorMessage = "ERROR_MSG.SYSTEM_ERROR";
          this.mockChart = HSET.chartData;
        }
      );
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
